import { ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialogLegacy } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { filter, Subscription } from 'rxjs';
import { CheckListService } from 'src/app/MaterialDialogs/check-list/check-list-service.service';
import { ReasonDisplayDialogComponent } from 'src/app/MaterialDialogs/reason-display-dialog/reason-display-dialog.component';
import { IAssignmentLogDetailsViewModel } from 'src/app/model/assignmentLog.model';
import { IChecklistLogsModel } from 'src/app/model/checkList.model';
import { ILoggedInUserViewModel } from 'src/app/model/common.model';
import { AppCategoryId } from 'src/app/service/category.model';
import { FilesService } from 'src/app/service/files.service';
import { GroupInvoicePayload } from 'src/app/service/generateInvoiceView.model';
import { NoteService } from 'src/app/service/note.service';
import { NotesService } from 'src/app/service/notes.service';
import { TripIdViewModel } from 'src/app/service/service-request';
import { ServiceRequestService } from 'src/app/service/service-request.service';
import { VendorService } from 'src/app/service/vendor.service';
import { PageName } from 'src/app/shared/enums/page-name.enum';
import { Constant, FileAttachmentTagStatusClassMap, RoleName } from '../../@shared/constants/Constant';
import { CreateNote } from '../../shared/interfaces/note.interface';
import { CreateFeedback } from '../../shared/interfaces/feedback.interface';
import { CustomerPointOfContact } from 'src/app/shared/enums/customer-point-of-contact.enum';
import { TemplateTextDialogComponent } from '@modules/service-request-template/components/template-text-dialog/template-text-dialog.component';
import { mobileDeviceCheck } from '@helpers/mobile-check.helper';
import { MatDialog } from '@angular/material/dialog';
import { ServiceRequestFileInterface } from '@interfaces/service-request/service-request-file.interface';
import { ViewFilesModalComponent } from '../../pages/v2/components/view-files-modal/view-files-modal.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedUiModule } from '../../@shared/shared-ui.module';

declare var $: any;
@Component({
  selector: 'app-note-feedback-file',
  templateUrl: './note-feedback-file.component.html',
  styleUrls: ['./note-feedback-file.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, SharedUiModule],
})
export class NoteFeedbackFileComponent implements OnInit, OnChanges, OnDestroy {
  @Input() serviceRequestId: string;
  @Input() detectChanges: boolean;
  @Input() feedbacks: any[];
  @Input() header: string;
  @Input() fromPage: any;
  @Input() srIdList: GroupInvoicePayload;
  @Input() isCatering: boolean;
  @Input() isTriggerFileDetails = true;
  @ViewChild('fileInput') fileInput: ElementRef;
  // TODO: Need To remove any type from this file.
  roleName = RoleName;
  files: ServiceRequestFileInterface[] = [];
  notes: any = [];
  SRLogs: any = [];
  SRSLogs: any = [];
  assignmnetLog: IAssignmentLogDetailsViewModel[] = [];
  checkListLogs: IChecklistLogsModel[] = [];
  loader = false;
  sortBy: string = 'fileType';
  sortOrder = true;
  prioritySorting = 'priority';
  prioritySortingFiles = 'isPinned';
  showButton: string = 'Note';
  p: number = 1;
  timeZone: any;
  display: boolean = false;
  currentPage: number = 1;
  pageSize: number = 10;
  selectedPage: number = 10;
  totalCount: number;
  pagination: string;
  pages = [10, 25, 50, 100];
  N: any;
  R: any;
  responsive: any;
  searchText1 = '';
  selectedPageForNotes: number = 5;
  selectedPageForFeedbacks: number = 5;
  selectedPageForFiles: number = 5;
  selectedPageForSRLogs: number = 5;
  selectedPageForSRSLogs: number = 5;
  selectedPageForAssignmnetLogs: number = 5;
  selectedPageForChecklistLogs: number = 5;
  currentPageForNotes: number = 1;
  currentPageForFeedback: number = 1;
  currentPageForFiles: number = 1;
  currentPageForSRLogs: number = 1;
  currentPageForSRSLogs: number = 1;
  currentPageForAssignmnetLogs: number = 1;
  currentPageForCheckListLogs: number = 1;
  searchNotes = '';
  searchFeedbacks = '';
  searchFiles = '';
  searchSRLogs = '';
  searchSRSLogs = '';
  searchAssignmnetLog = '';
  searchChecklistLogs = '';
  notesPagination: string = '';
  feedbackPagination: string = '';
  filePagination: string = '';
  SRLogsPaginationDes: string = '';
  SRSLogsPagination: string = '';
  assignmnetLogsPagination: string = '';
  checkListLogsPagination: string = '';
  SRLogsPagination: number = 1;
  categoryList: AppCategoryId[] = [];
  categories = [
    { id: 1, name: 'Aircraft' },
    { id: 2, name: 'Catering' },
    { id: 3, name: 'Drop off info' },
    { id: 4, name: 'Ground' },
    { id: 5, name: 'Pick up' },
    { id: 6, name: 'Service Failure' },
    { id: 7, name: 'Team' },
    { id: 8, name: 'Weather' },
    { id: 9, name: 'Others' },
  ];
  categoriesForCustomer: AppCategoryId[] = [];
  numberOfEntries = [
    { id: 1, numberOfEntries: '5' },
    { id: 2, numberOfEntries: '10' },
    { id: 3, numberOfEntries: '15' },
    { id: 4, numberOfEntries: '20' },
  ];
  numberOfEntriesForLegLogs = [5, 10, 15, 20, 50, 100];
  createNoteModel: CreateNote = new CreateNote();
  user: ILoggedInUserViewModel;
  //notes sorting......
  notesSortBy: string = 'priority';
  date: boolean = false;
  by: boolean = false;
  category: boolean = false;
  note: boolean = false;

  //SRLogs sorting
  SRLogsSortBy: string = 'createdOn';
  SRLogsOrigin = false;
  SRLogsDestination = false;
  SRLogsPreviousStatus = false;
  SRLogsUpdatedStatus = false;
  SRLogsUpdatedTime = false;
  SRLogsUpdatedBy = false;
  SRLogsOperationType = false;
  SRLogsPreviousValues = false;
  SRLogsUpdatedValues = false;

  //Assignmnet logs sorting
  assignmentLogSortBy: string = 'createdOn';
  assignmentLogLegSeqNumber = false;
  assignmentLogName = false;
  assignmentLogOrigin = false;
  assignmentLogDestination = false;
  assignmentLogUpdatedTime = false;
  assignmentLogUpdatedBy = false;
  assignmentLogOperationType = false;
  assignmentLogPreviousValues = false;
  assignmentLogUpdatedValues = false;

  //Checklist logs sorting
  checklistLogSortBy: string = 'lastUpdatedOn';
  checklistLogIndex = false;
  checklistLogName = false;
  checklistLogUpdatedOn = false;
  checklistLogUpdatedBy = false;
  checklistLogPreviousValue = false;
  checklistLogUpdatedValue = false;

  //feedback sorting...
  feedbackSortBy: string = 'createdOn';
  organization: boolean = false;
  feedbackRating: boolean = false;
  feedback: boolean = false;

  //file sorting.
  sortFileType: string = 'fileName';
  fileName: boolean = false;
  fileCreatedBy: boolean = false;
  uploadedOnColumn = false;
  fileTag: boolean = false;

  // leg logs sorting.
  legsLogSortBy: string = 'updatedOn';
  LegNumber: boolean = false;
  legOrigin: boolean = false;
  legDestination: boolean = false;
  legPreviousStatus: boolean = false;
  legUpdatedStatus: boolean = false;
  legUpdatedTime: boolean = false;
  legUpdatedBy: boolean = false;
  legOperationType: boolean = false;
  legPreviousValues: boolean = false;
  legUpdatedValues: boolean = false;
  userBusinessUnitId: any;

  isMobileDevice = true;
  selectedCategory: any = '';
  noteFeedback: string;
  rating: number = 0;
  cateringLogLength: number = 0;
  fileAttachmentTagStatusClass = FileAttachmentTagStatusClassMap;
  chooseFile: ServiceRequestFileInterface[] = [];
  totalCountFiles = 0;
  private _subscriptions: Subscription = new Subscription();

  constructor(
    private _toastr: ToastrService,
    private _vendorService: VendorService,
    private _noteService: NoteService,
    private _fileService: FilesService,
    private _serviceRequestService: ServiceRequestService,
    private _checklistService: CheckListService,
    private _cdr: ChangeDetectorRef,
    private _notesService: NotesService,
    private _dialog: MatDialogLegacy,
    private readonly dialog: MatDialog,
  ) {
    this._serviceRequestService.legRecordUpdate.subscribe((value) => {
      this.getServiceRequestStepLogs(value);
    });
    this._serviceRequestService.timZoneChange.subscribe((value) => {
      this.timeZone = Constant.selectedTimeZoneShortValue;
    });
    this.timeZone = Constant.selectedTimeZoneShortValue;

    this._checklistService.triggerGetChekListLogMethod.subscribe((response: string) => {
      this.getChecklistLogs(response);
    });
  }
  isInternalReadOnly: boolean = false;
  isAdmin: boolean = false;
  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.isInternalReadOnly = this.user.role === RoleName.InternalReadOnly;
    this.isAdmin =
      this.user.role === RoleName.ExecutiveAdmin ||
      this.user.role === RoleName.Coordinator ||
      this.user.role === RoleName.Management ||
      this.user.role === RoleName.Accounting;
    if (this.user.role == 'Customer Admin') this.showButton = 'Feedback';
    this.isMobileDevice = mobileDeviceCheck();

    this._notesService.$fetchNotes.subscribe((type) => {
      type == 'Priority' ? this.getNotesByID(this.serviceRequestId, this.userBusinessUnitId) : this.getAllNotes();
    });
  }

  ngOnChanges() {
    this.user = JSON.parse(localStorage.getItem('user'));
    if (this.fromPage == 'Itinary') this.loader = false;
    if (this.srIdList != undefined || this.srIdList != null) {
      this.serviceRequestId = this.srIdList.serviceRequestID[0];
      this.getTripIdByServiceRequestList(this.srIdList);
      this.getGroupNotes(this.srIdList, this.user.businessUnitId);
    } else {
      this.userBusinessUnitId = this.user.businessUnitId;
      this.getNotesByID(this.serviceRequestId, this.userBusinessUnitId);
      this.getFile(this.fromPage, this.serviceRequestId);
    }
    this.openAddNoteFeedbackModel(this.fromPage);
    this.popupFilterFileType = this.chooseFile;
    this.getCustomerCategory();
    if (this.srIdList == undefined || this.srIdList == null) {
      this.getServiceRequestLogs(this.serviceRequestId);
      this.getServiceRequestStepLogs(this.serviceRequestId);
      this.getAssignmentLogDetails(this.serviceRequestId);
    }
    if (this.fromPage == 'Preview') {
      this.getChecklistLogs(this.serviceRequestId);
    }
    this.feedbackPagination = Constant.showPaginationMessage(
      this.feedbacks.length,
      this.currentPageForFeedback,
      this.selectedPageForFeedbacks,
    );
    this.filePagination = Constant.showPaginationMessage(this.files.length, this.currentPageForFiles, this.selectedPageForFiles);

    if (this.serviceRequestId) {
      this.getFile(this.fromPage, this.serviceRequestId);
    }
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  trackByFn(index: number, item: any): string {
    return item.fileId;
  }

  cancellationReasonPopUp(srCancellationReasonId: string): void {
    this._dialog.open(ReasonDisplayDialogComponent, {
      minWidth: '25%',
      maxWidth: '20%',
      position: {
        top: '1rem',
      },
      data: srCancellationReasonId,
    });
  }

  openAddNoteFeedbackModel(head) {
    this.header = head;
    if (this.fromPage != 'customer' || this.fromPage == 'createItenary') this.getCategoryList();
    else this.getCustomerCategory();
  }

  deleteNote(noteId: string) {
    this._noteService.deleteNotes(noteId).subscribe((response) => {
      if (this.srIdList != null || this.srIdList != undefined) {
        this.getGroupNotes(this.srIdList, this.user.businessUnitId);
      } else {
        this.getAllNotes();
      }
    });
  }

  getAllNotes() {
    this._noteService.getAllServiceRequestLevelNote(this.serviceRequestId, this.userBusinessUnitId).subscribe((response) => {
      this.notes = response;
      this.notesPagination = Constant.showPaginationMessage(this.notes.length, this.currentPageForNotes, this.selectedPageForNotes);
      this._cdr.detectChanges();
    });
  }
  createFeedback: CreateFeedback = new CreateFeedback();
  saveNoteFeedbackData() {
    var date =
      new Date().getDate() +
      '/' +
      (new Date().getMonth() + 1) +
      '/' +
      new Date().getFullYear() +
      ' ' +
      new Date().getHours() +
      ':' +
      new Date().getMinutes();
    if (this.noteFeedback != '' && this.noteFeedback != undefined) {
      if (this.header == 'Note') {
        this.fillNoteData();
      } else {
        this.loader = true;
        this.createFeedback.createdBy = this.user['memberId'];
        this.createFeedback.feedback = this.noteFeedback;
        this.createFeedback.rating = this.rating;
        this.createFeedback.feedbackType =
          this.user.memberType == 'Vendor' ? 'Vendor' : this.user.memberType == 'Customer' ? 'Customer' : 'ServiceRequest';
        this.createFeedback.businessUnitId = this.serviceRequestId;
        this.createFeedback.userBusinessUnitId = this.userBusinessUnitId;
        this._noteService.createFeedback(this.createFeedback).subscribe((response) => {
          this.display = false;
          this.loader = false;
          this.getAllFeedback();
        });
        this.rating = 0;
        this.noteFeedback = '';
        $('#addNoteFeedback').modal('hide');
        this.successMessage('Feedback Added Successfully!');
        this.feedbackPagination = Constant.showPaginationMessage(
          this.feedbacks.length,
          this.currentPageForFeedback,
          this.selectedPageForFeedbacks,
        );
      }
    } else {
      this.errorMessage('Please fill all required fields!');
    }
  }
  fillNoteData() {
    if (this.selectedCategory != '' && this.selectedCategory != undefined && this.noteFeedback != '' && this.noteFeedback != undefined) {
      this.loader = true;
      this.createNoteModel.createdBy = this.user['memberId'];
      this.createNoteModel.category = this.selectedCategory;
      this.createNoteModel.noteDescription = this.noteFeedback;
      this.createNoteModel.noteType = this.user.memberType == 'Vendor' ? 'VendorNote' : 'ServiceRequest';
      this.createNoteModel.businessUnitId = this.serviceRequestId;
      this.createNoteModel.userBusinessUnitId = this.user['businessUnitId'];
      this._noteService.createNote(this.createNoteModel).subscribe((response) => {
        this.display = false;
        this.loader = false;
        if (this.srIdList != undefined || this.srIdList != null) this.getGroupNotes(this.srIdList, this.user.businessUnitId);
        else this.getAllNotes();
      });
      this.selectedCategory = '';
      this.noteFeedback = '';
      this.selectedTripId = undefined;
      $('#addNoteFeedback').modal('hide');
      this.successMessage('Note Added SuccessFully!');
      this.notesPagination = Constant.showPaginationMessage(this.notes.length, this.currentPageForNotes, this.selectedPageForNotes);
    } else {
      this.errorMessage('Please fill all required fields!');
    }
  }

  successMessage(msg) {
    this._toastr.success(msg, 'Success!', {
      timeOut: 2000,
      positionClass: 'toast-top-center',
    });
  }
  errorMessage(msg) {
    this._toastr.error(msg, 'Error', {
      timeOut: 2000,
      positionClass: 'toast-top-center',
    });
  }
  oldFileData = [];

  openCreateFileModal(): void {
    this.dialog
      .open(ViewFilesModalComponent, {
        width: '900px',
        panelClass: 'no-padding',
        data: {
          serviceRequestId: this.serviceRequestId,
          fromPage: this.fromPage,
          isFileEditable: true,
          isTagRequired: true,
        },
      })
      .afterClosed()
      .pipe(filter(Boolean))
      .subscribe(() => {
        this.selectedPage = 1;
        this.getFile(this.fromPage, this.serviceRequestId);
      });
  }

  openEditFileModal(file: ServiceRequestFileInterface): void {
    this.dialog
      .open(ViewFilesModalComponent, {
        width: '900px',
        panelClass: 'no-padding',
        data: {
          serviceRequestId: this.serviceRequestId,
          fromPage: this.fromPage,
          selectedFile: file,
          isFileEditable: true,
          isTagRequired: true,
        },
      })
      .afterClosed()
      .pipe(filter(Boolean))
      .subscribe(() => {
        this.currentPageForFiles = 1;
        this.getFile(this.fromPage, this.serviceRequestId);
      });
  }

  popupFilterFileType = [];
  copyArr = [];
  searchText: string;
  editAllFile1: boolean = false;

  closeViewFileModel(flag) {
    this.chooseFile.forEach((item) => {
      item.isEditable = false;
    });
    this.editAllFile1 = false;
    if (flag == true) this.chooseFile = [...this.oldFileData];
    this.filePagination = Constant.showPaginationMessage(this.files.length, this.currentPageForFiles, this.selectedPageForFiles);
  }

  editAllFile() {
    this.copyArr = [...this.chooseFile].map((item) => ({ ...item }));
    this.chooseFile.forEach((item) => {
      item.isEditable = true;
    });
    this.editAllFile1 = true;
  }

  closeAll() {
    this.chooseFile = this.copyArr;
    this.editAllFile1 = false;
  }

  removeFile(id, index?) {
    if (id !== 0) {
      this._vendorService.deletedFile('fileId=' + id).subscribe((response) => {
        this._toastr.success('Deleted file Successfully', 'Success', { positionClass: 'toast-top-center', timeOut: 6000 });
        this.ngOnChanges();
      });
    } else {
      this.chooseFile.splice(index, 1);
    }
  }

  selectMemberPage(cardName) {
    switch (cardName) {
      case 'Notes':
        this.currentPageForNotes = 1;
        this.notesPagination = Constant.showPaginationMessage(this.notes.length, this.currentPageForNotes, this.selectedPageForNotes);
        break;
      case 'Feedbacks':
        this.currentPageForFeedback = 1;
        this.feedbackPagination = Constant.showPaginationMessage(
          this.feedbacks.length,
          this.currentPageForFeedback,
          this.selectedPageForFeedbacks,
        );
        break;
      case 'SRLogs':
        this.currentPageForSRLogs = 1;
        this.SRLogsPaginationDes = Constant.showPaginationMessage(
          this.SRLogs.length,
          this.currentPageForSRLogs,
          this.selectedPageForSRLogs,
        );
        break;
      case 'SRSLogs':
        this.currentPageForSRSLogs = 1;
        this.SRSLogsPagination = Constant.showPaginationMessage(
          this.SRSLogs.length,
          this.currentPageForSRSLogs,
          this.selectedPageForSRSLogs,
        );
        break;
      case 'AssignmnetLogs':
        this.currentPageForAssignmnetLogs = 1;
        this.assignmnetLogsPagination = Constant.showPaginationMessage(
          this.assignmnetLog.length,
          this.currentPageForAssignmnetLogs,
          this.selectedPageForAssignmnetLogs,
        );
        break;
      case 'CheckListLogs':
        this.currentPageForCheckListLogs = 1;
        this.checkListLogsPagination = Constant.showPaginationMessage(
          this.checkListLogs.length,
          this.currentPageForCheckListLogs,
          this.selectedPageForChecklistLogs,
        );
        break;
      default:
        this.currentPageForFiles = 1;
        this.getFile(this.fromPage, this.serviceRequestId);
        break;
    }
  }

  currentPageChange(cardName) {
    switch (cardName) {
      case 'Notes':
        this.notesPagination = Constant.showPaginationMessage(this.notes.length, this.currentPageForNotes, this.selectedPageForNotes);
        break;
      case 'Feedbacks':
        this.feedbackPagination = Constant.showPaginationMessage(
          this.feedbacks.length,
          this.currentPageForFeedback,
          this.selectedPageForFeedbacks,
        );
        break;
      case 'SRLogs':
        this.SRLogsPaginationDes = Constant.showPaginationMessage(
          this.SRLogs.length,
          this.currentPageForSRLogs,
          this.selectedPageForSRLogs,
        );
        break;
      case 'SRSLogs':
        this.SRSLogsPagination = Constant.showPaginationMessage(
          this.SRSLogs.length,
          this.currentPageForSRSLogs,
          this.selectedPageForSRSLogs,
        );
        break;
      case 'AssignmnetLogs':
        this.assignmnetLogsPagination = Constant.showPaginationMessage(
          this.assignmnetLog.length,
          this.currentPageForAssignmnetLogs,
          this.selectedPageForAssignmnetLogs,
        );
        break;
      case 'CheckListLogs':
        this.checkListLogsPagination = Constant.showPaginationMessage(
          this.checkListLogs.length,
          this.currentPageForCheckListLogs,
          this.selectedPageForChecklistLogs,
        );
        break;
      default:
        this.filePagination = Constant.showPaginationMessage(this.files.length, this.currentPageForFiles, this.selectedPageForFiles);
        break;
    }
  }

  onPageChangeFiles(value: number): void {
    this.currentPageForFiles = value;
    this.currentPageChange('Files');
    this.getFile(this.fromPage, this.serviceRequestId);
  }

  getCategoryList() {
    if (this._vendorService.appCategoryIdList$.value.length > 0) {
      this.categoryList = this._vendorService.appCategoryIdList$.value;
    } else {
      this._vendorService.getAppCategoryData().subscribe((response) => {
        this.categoryList = response;
      });
    }
  }

  getCustomerCategory() {
    this._vendorService.getCustomerNoteCategory().subscribe((response) => {
      this.categoriesForCustomer = response;
    });
  }

  getAllFeedback() {
    this._noteService.getAllFeedbackByBuId(this.serviceRequestId, this.userBusinessUnitId).subscribe((response) => {
      this.feedbacks = response;
      this.feedbackPagination = Constant.showPaginationMessage(
        this.feedbacks.length,
        this.currentPageForFeedback,
        this.selectedPageForFeedbacks,
      );
    });
  }

  clearData() {
    this.selectedCategory = '';
    this.noteFeedback = '';
    this.rating = 0;
    this.noteFeedback = '';
    this.selectedTripId = undefined;
    this.display = false;
  }

  multipleFileUpload: any;
  path: string = '';
  deletedFile = [];
  noteSize(value) {
    if (this.noteFeedback == '' || this.noteFeedback == null) {
      this.display = false;
    } else if (value.length > 500) {
      this.display = true;
    } else this.display = false;
  }

  getFile(fromPage: string, businessUnitId: string): void {
    if (fromPage === 'Preview') {
      fromPage = 'Itinary';
    }

    this._fileService.fetchFiles(fromPage, businessUnitId, this.currentPageForFiles, this.selectedPageForFiles).subscribe((response) => {
      this.files = response.items.map((item) => {
        return {
          ...item,
          fileName: item.displayName.split('.')[0],
          extension: item.displayName.split('.')[1],
        };
      });
      this.totalCountFiles = response.count;
      this.chooseFile = this.files;
      this.filePagination = Constant.showPaginationMessage(this.totalCountFiles, this.currentPageForFiles, this.selectedPageForFiles);
    });
    this.chooseFile = this.files;
    this.filePagination = Constant.showPaginationMessage(this.files.length, this.currentPageForFiles, this.selectedPageForFiles);
  }

  pinItem(item): void {
    this._fileService.pinFile(item.fileId).subscribe(() => {
      this.currentPageForFiles = 1;
      this.getFile(this.fromPage, this.serviceRequestId);
    });
  }

  getNotesByID(businessUnitID, userBusinessUnitId) {
    this.notes = [];
    this._noteService.getAllServiceRequestLevelNote(businessUnitID, userBusinessUnitId).subscribe(
      (response) => {
        this.notes = [...response];
        this.getAllFeedback();
        this.notesPagination = Constant.showPaginationMessage(this.notes.length, this.currentPageForNotes, this.selectedPageForNotes);
        this.loader = false;
        this._cdr.detectChanges();
      },
      () => {
        this.loader = false;
      },
    );
  }

  getServiceRequestLogs(businessUnitID) {
    this.SRLogs = [];
    this._serviceRequestService.getServiceRequestLogs(businessUnitID).subscribe(
      (response) => {
        this.SRLogs = response;
        this.SRLogsPaginationDes = Constant.showPaginationMessage(
          this.SRLogs.length,
          this.currentPageForSRLogs,
          this.selectedPageForSRLogs,
        );
        this.loader = false;
      },
      () => {
        this.loader = false;
      },
    );
  }

  getServiceRequestStepLogs(businessUnitID) {
    this.SRSLogs = [];
    this._serviceRequestService.getServiceRequestStepsLogs(businessUnitID).subscribe(
      (response) => {
        this.SRSLogs = response;
        this.SRSLogsPagination = Constant.showPaginationMessage(
          this.SRSLogs.length,
          this.currentPageForSRSLogs,
          this.selectedPageForSRSLogs,
        );
        this.loader = false;
      },
      () => {
        this.loader = false;
      },
    );
  }
  getAssignmentLogDetails(businessUnitID) {
    this.SRSLogs = [];
    this._serviceRequestService.getAssignmentLogDetails(businessUnitID).subscribe(
      (response) => {
        this.assignmnetLog = response;
        this.updateNameForCustomerAndSubCustomer();
        this.assignmnetLogsPagination = Constant.showPaginationMessage(
          this.assignmnetLog.length,
          this.currentPageForAssignmnetLogs,
          this.selectedPageForAssignmnetLogs,
        );
      },
      () => {
        this.loader = false;
      },
    );
  }
  getGroupNotes(srIdList: GroupInvoicePayload, businessUnitId: string) {
    this._noteService.getGroupNotes(srIdList, businessUnitId).subscribe(
      (response) => {
        this.notes = [];
        this.notes = [...response];
        this.notesPagination = Constant.showPaginationMessage(this.notes.length, this.currentPageForNotes, this.selectedPageForNotes);
        this.loader = false;
      },
      () => {
        this.loader = false;
      },
    );
  }
  selectedTripId: any;
  tripIdListByServiceRequest: TripIdViewModel[];
  getTripIdByServiceRequestList(srIdList: GroupInvoicePayload) {
    this._serviceRequestService.getTripIdByServiceRequestList(srIdList).subscribe(
      (response) => {
        this.tripIdListByServiceRequest = response;
      },
      (error) => {
        this._toastr.warning('Something Went Wrong!', 'Warning', { timeOut: 6000, positionClass: 'toast-top-center' });
      },
    );
  }

  changeTripId(event) {
    this.serviceRequestId = event.target.value;
  }

  saveFinanceNote() {
    if (this.tripIdListByServiceRequest != undefined && this.tripIdListByServiceRequest.length == 1 && this.selectedTripId == undefined) {
      this.fillNoteData();
    } else if (
      this.tripIdListByServiceRequest != undefined &&
      this.tripIdListByServiceRequest.length > 1 &&
      this.selectedTripId != undefined
    ) {
      this.fillNoteData();
    } else {
      this.errorMessage('Please fill all required fields!');
    }
  }

  notePriority(note) {
    let priority;
    if (note.priority != null) {
      priority = note.priority == false ? true : false;
    } else {
      priority = true;
    }
    this._noteService.notePriority(note.noteID, priority).subscribe(
      (response) => {
        this.userBusinessUnitId = this.user.businessUnitId;
        this.getNotesByID(this.serviceRequestId, this.userBusinessUnitId);
        this.successMessage('Note Priority Updated Successfully');
      },
      () => {
        this._toastr.warning('Something went wrong! Please try again', 'Warning', { timeOut: 6000, positionClass: 'toast-top-center' });
      },
    );
  }

  getChecklistLogs(serviceRequestId: string) {
    this._checklistService.getCheckListLogs(serviceRequestId).subscribe(
      (response) => {
        this.checkListLogs = response.data != null ? response.data : [];
        this.checkListLogsPagination = Constant.showPaginationMessage(
          this.checkListLogs.length,
          this.currentPageForCheckListLogs,
          this.selectedPageForChecklistLogs,
        );
      },
      () => {
        this._toastr.warning('Something Went Wrong! Could not get the checklist logs!', 'Warning', {
          timeOut: 6000,
          positionClass: 'toast-top-center',
        });
      },
    );
  }

  cateringLogsLength(event: number): void {
    this.cateringLogLength = event;
  }

  isCustomerOrVendorPage(): boolean {
    return this.fromPage !== PageName.vendor && this.fromPage !== PageName.customer;
  }

  updateNameForCustomerAndSubCustomer() {
    this.assignmnetLog.forEach((log) => {
      switch (true) {
        case log.updatedValues.includes(CustomerPointOfContact.customer) && !log.updatedValues.includes(CustomerPointOfContact.subCustomer):
          log.assignedMember = log.updatedValues.replace(CustomerPointOfContact.customer, '').trim();
          break;
        case log.updatedValues.includes(CustomerPointOfContact.subCustomer) && !log.updatedValues.includes('|'):
          log.assignedMember = log.updatedValues.replace(CustomerPointOfContact.subCustomer, '').trim();
          break;
        case log.updatedValues.includes(CustomerPointOfContact.customer) &&
          log.updatedValues.includes(CustomerPointOfContact.subCustomer) &&
          log.updatedValues.includes('|'):
          log.customerPointOfContacts = log.updatedValues.split('|');
          break;
      }
    });
  }

  showTemplateTextDialog(templateId: string): void {
    this._dialog.open(TemplateTextDialogComponent, {
      minWidth: '45%',
      maxWidth: '50vw',
      panelClass: 'dialog-wrap',
      data: {
        templateId,
      },
    });
  }

  sortColumn(fieldName: string, fieldValue: string): void {
    this.sortFileType = fieldValue;
    this.sortOrder = !this.sortOrder;
    this[fieldName] = !this[fieldName];
  }

  downloadFile(file: ServiceRequestFileInterface): void {
    if (!file.fileName) return;
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.href = file.filePath;
    a.download = file.displayName;
    a.click();
    document.body.removeChild(a);
  }
}
